import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useContextualPathTransformer from '../../../../hooks/use-contextual-path-transformer.js';
import { MainTitle, SubTitle } from '~/components/misc/section-head.js';
import ButtonOutlined from '../components/controls/buttons.js';
import Icon, { ICON_CLOSE } from '~/components/icon/index.js';
import { ROUTE_ACCOUNT_WE_SPIN_DASHBOARD } from '../constants/we-spin-route-constants.js';
import { selectIsStreamer } from '../ducks/we-spin-dashboard-duck.js';
import { useCloseCurrentContext } from '~/hooks/use-close-context.js';

const WeSpinGameRoomEventNotFound = () => {
	const navigate = useNavigate();
	const transformPath = useContextualPathTransformer();
	const isStreamer = useSelector(selectIsStreamer);
	const onCloseSidebar = useCloseCurrentContext();
	const onGoToLobbyClick = () => {
		if (isStreamer) {
			const link = transformPath(ROUTE_ACCOUNT_WE_SPIN_DASHBOARD);
			navigate(link);
		} else {
			onCloseSidebar();
		}
	};

	return (
		<>
			<div className="u-fxb-center-v-h u-mt2">
				<Icon type={ICON_CLOSE} width="56" height="56" />
			</div>
			<div className="u-width-100 u-text-c u-mt1">
				<MainTitle>Stream Unavailable</MainTitle>
			</div>
			<div className="u-width-100 u-text-c u-mt1">
				<SubTitle>Sorry but we can no longer find the stream you are looking for.</SubTitle>
			</div>
			<div className="u-fxb-center-v-h u-mt2">
				<ButtonOutlined className="btn u-1-2-width" onClick={onGoToLobbyClick}>
					Go To Lobby
				</ButtonOutlined>
			</div>
		</>
	);
};

export default WeSpinGameRoomEventNotFound;
